var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12H8.5C8.36739 12 8.24021 11.9473 8.14645 11.8536C8.05268 11.7598 8 11.6326 8 11.5C8 11.3674 8.05268 11.2402 8.14645 11.1464C8.24021 11.0527 8.36739 11 8.5 11H9.5C9.89783 11 10.2794 10.842 10.5607 10.5607C10.842 10.2794 11 9.89783 11 9.5V8.5C11 8.36739 11.0527 8.24021 11.1464 8.14645C11.2402 8.05268 11.3674 8 11.5 8C11.6326 8 11.7598 8.05268 11.8536 8.14645C11.9473 8.24021 12 8.36739 12 8.5V9.5C11.9992 10.1628 11.7356 10.7982 11.2669 11.2669C10.7982 11.7356 10.1628 11.9992 9.5 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.367392 4 0.240215 3.94732 0.146447 3.85355C0.0526784 3.75979 0 3.63261 0 3.5V2.5C0.000793929 1.8372 0.264441 1.20178 0.73311 0.73311C1.20178 0.264441 1.8372 0.000793929 2.5 0L3.5 0C3.63261 0 3.75979 0.0526784 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5C4 0.632608 3.94732 0.759785 3.85355 0.853554C3.75979 0.947322 3.63261 1 3.5 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V3.5C1 3.63261 0.947322 3.75979 0.853554 3.85355C0.759785 3.94732 0.632608 4 0.5 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12H2.5C1.8372 11.9992 1.20178 11.7356 0.73311 11.2669C0.264441 10.7982 0.000793929 10.1628 0 9.5L0 8.5C0 8.36739 0.0526784 8.24021 0.146447 8.14645C0.240215 8.05268 0.367392 8 0.5 8C0.632608 8 0.759785 8.05268 0.853554 8.14645C0.947322 8.24021 1 8.36739 1 8.5V9.5C1 9.89783 1.15804 10.2794 1.43934 10.5607C1.72064 10.842 2.10218 11 2.5 11H3.5C3.63261 11 3.75979 11.0527 3.85355 11.1464C3.94732 11.2402 4 11.3674 4 11.5C4 11.6326 3.94732 11.7598 3.85355 11.8536C3.75979 11.9473 3.63261 12 3.5 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C11.3674 4 11.2402 3.94732 11.1464 3.85355C11.0527 3.75979 11 3.63261 11 3.5V2.5C11 2.10218 10.842 1.72064 10.5607 1.43934C10.2794 1.15804 9.89783 1 9.5 1H8.5C8.36739 1 8.24021 0.947322 8.14645 0.853554C8.05268 0.759785 8 0.632608 8 0.5C8 0.367392 8.05268 0.240215 8.14645 0.146447C8.24021 0.0526784 8.36739 0 8.5 0L9.5 0C10.1628 0.000793929 10.7982 0.264441 11.2669 0.73311C11.7356 1.20178 11.9992 1.8372 12 2.5V3.5C12 3.63261 11.9473 3.75979 11.8536 3.85355C11.7598 3.94732 11.6326 4 11.5 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoomIcon.96f719f775a5856304cca54eff162b29.svg";
export { ForwardRef as ReactComponent };